<div class="reset-password-bdp content-without-footer d-flex">
    <app-sprintpay-reset-password
        class="position-absolute"
        [widthLogo]="'156'"
        [heightLogo]="'26'"
    ></app-sprintpay-reset-password>
</div>
